// extracted by mini-css-extract-plugin
export default {"root":"root--dl-b9","body":"body--dl-b9","attribution":"attribution--dl-b9"};